/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import useTimeMachine from '../../../hooks/useTimeMachine';
import { ITimeMachine } from '../../../interfaces/ITimeMachine';
import Cell from '../../cell';
import './Colors.scss';

type IColor = Array<boolean>;

const Colors = () => {
  const {
    state,
    updateValues,
    current,
    previous,
    next,
    resume,
    isEditable,
    reset,
  }: ITimeMachine<IColor> = useTimeMachine<IColor>(Array(16).fill(false));

  const handleClick = (index: number, element: boolean) => {
    if (isEditable) {
      if (!element) {
        const newArray = Array<boolean>(16).fill(false);
        newArray[index] = true;
        updateValues(newArray);
      }
    }
  };

  const renderSquare = (i: number, element: boolean) => (
    <Cell
      key={i}
      value={element}
      onClick={() => handleClick(i, element)}
    />
  );

  const resetGrid = () => {
    reset();
  };

  return (
    <div>
      <h1 className="title-board">Simon says</h1>
      <div className="board-container">
        <div className="grid">
          {state[current].map((element: boolean, index: number) => (
            renderSquare(index, element)
          ))}
        </div>
        <div className="container-button">
          <button type="button" onClick={previous} className={(current === (state.length - 1)) ? 'option-button disabled' : 'option-button'}>Previous</button>
          <button type="button" onClick={resume} className={(current === 0) ? 'option-button disabled' : 'option-button'}>Resume</button>
          <button type="button" onClick={next} className={(current === 0) ? 'option-button disabled' : 'option-button'}>Next</button>
          <button
            type="button"
            onClick={resetGrid}
            className="option-button"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};
export default Colors;
